const getCanvasBlob = (canvas: HTMLCanvasElement, type: string): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) {
        resolve(blob)
      } else {
        reject(new Error(`Cannot convert image into blob`))
      }
    }, type)
  })
}

export async function rotateImage(imageFile: File): Promise<File> {
  try {
    const { default: loadImage } = await import('blueimp-load-image')

    const {
      image: result,
      imageHead,
      exif,
      exifOffsets,
      ...rest
    } = await loadImage(imageFile, { meta: true, orientation: true, canvas: true })

    const canvas = result as HTMLCanvasElement

    let blob = await getCanvasBlob(canvas, imageFile.type)
    if (imageHead && exif && exifOffsets) {
      loadImage.writeExifData(imageHead, { exif, exifOffsets, ...rest }, 'Orientation', 1)

      const blobWithMetadata = await loadImage.replaceHead(blob, imageHead)
      if (blobWithMetadata) {
        blob = blobWithMetadata
      }
    }

    return new File([blob], imageFile.name, { type: imageFile.type })
  } catch {
    return imageFile
  }
}

export async function convertHeicHeifFileToJpeg(imageFile: File): Promise<File> {
  try {
    const { heicTo } = await import('heic-to')

    const convertedBlob = await heicTo({
      blob: imageFile,
      type: 'image/jpeg',
      quality: 0.8,
    })

    return new File([convertedBlob], imageFile.name.replace(/\.[^.]+$/, '.jpeg'), {
      type: 'image/jpeg',
    })
  } catch {
    return imageFile
  }
}

export async function getFileMetaInfo(file: File) {
  const { default: exifr } = await import('exifr')

  const [gps, orientation] = await Promise.all([exifr.gps(file), exifr.orientation(file)])

  return { latitude: gps?.latitude, longitude: gps?.longitude, orientation }
}
